import React from 'react';
import {
    CreateButton,
    ExportButton,
    InfiniteList as RaInfiniteList,
    SearchInput,
    TopToolbar as RaToopToolbar,
} from 'react-admin';
import { InfiniteLoad } from './InfiniteLoad';
import { dataObject } from '@src/object.type';

const TopToolbar: React.FC<{
    uploadButton?: React.ReactNode;
    generateButton?: React.ReactNode;
    generateQrButton?: React.ReactNode;
}> = ({ uploadButton, generateButton, generateQrButton }) => (
    <RaToopToolbar>
        {generateQrButton}
        {generateButton}
        {uploadButton}
        <CreateButton />
        <ExportButton maxResults={1000000} />
    </RaToopToolbar>
);

const filters = [
    <SearchInput
        key="q"
        source="q"
        alwaysOn
        variant="standard"
        sx={{ debounce: 3000 }}
    />,
];

export const InfiniteList: React.FC<{
    children: React.ReactNode;
    generateButton?: React.ReactNode;
    uploadButton?: React.ReactNode;
    generateQrButton?: React.ReactNode;
    filtersNodes?: React.ReactElement[];
    exporter?: (d: dataObject[]) => void;
}> = ({
    children,
    generateButton,
    uploadButton,
    generateQrButton,
    filtersNodes = [],
    exporter,
}) => {
    return (
        <RaInfiniteList
            actions={
                <TopToolbar
                    generateQrButton={generateQrButton}
                    generateButton={generateButton}
                    uploadButton={uploadButton}
                />
            }
            empty={false}
            pagination={<InfiniteLoad />}
            perPage={10}
            exporter={exporter}
            filters={[...filters, ...filtersNodes]}
        >
            {children}
        </RaInfiniteList>
    );
};
